module.exports = __webpack_public_path__ + "img/fit_bg.488398eb.png";